<template>
    <!-- 权限配置 -->
    <div class="module myticket">
        <helpinfo style="background-color:white"
                  :helpData="helpData" />
        <div class="module-container">
            <div class="container">
                <rcTable ref="rcTable"
                         :tableAttr="tableAttr">
                    <Button slot="tootipL"
                            @click="refresh">
                        <i class="icon-refresh-o-2"></i>
                    </Button>
                    <Button @click="createClick"
                            slot="tootipL"
                            :disabled="!hasPermission('CH0502')"
                            type="primary">
                        <i class="icon-plus-o-1"></i>{{$t('创建')}}
                    </Button>
                </rcTable>
            </div>
        </div>
        <!--关联用户-->
        <associatedusers ref="associatedusers"
                         @refresh="refresh"></associatedusers>
        <!--调整权限-->
        <authorize ref="authorize"
                   @refresh="refresh"></authorize>
        <!--编辑/船舰授权-->
        <createstrategy ref="createstrategy"
                        @refresh="refresh"></createstrategy>
        <!-- 关联资源 -->
        <associatedresource ref="associatedresource"
                            @refresh="refresh"></associatedresource>
    </div>
</template>

<script>
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import API from '@/service/api.js'
import associatedusers from './components/associatedusers'
import associatedresource from '@/views/console/accesscontrol/strategy/components/associatedresource'
import authorize from './components/authorize'
import createstrategy from './components/createstrategy'
export default {
    name: 'strategy',
    components: {
        helpinfo,
        rcTable,
        associatedusers,
        authorize,
        createstrategy,
        associatedresource
    },
    data () {
        return {
            helpData: {
                modelName: this.$t('权限配置')
            },
            policyTypeName: {
                system: this.$t('系统内置'),
                custom: this.$t('自定义')
            },
            // resourceTypeName: {
            //     all: this.$t('全部'),
            //     ecs: this.$t('云主机'),
            //     disk: this.$t('云硬盘'),
            //     floatingIp: this.$t('弹性公网IP'),
            //     billing: this.$t('费用中心'),
            //     ticket: this.$t('工单')
            // },
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.ACCESS_POLICES, false),
                    params: {}
                },
                isMultiSelect: false,
                searchShow: true,
                columnsChooseShow: true,
                searchColumns: [
                    {
                        key: 'policyNameLike',
                        title: this.$i18n.t('标识'),
                        searchDefaultValue: ''
                    },
                    {
                        key: 'resourceTypesLike',
                        title: this.$i18n.t('资源类型'),
                        searchDefaultValue: '',
                        searchType: 'select',
                        searchData: []
                    }
                ],
                referenceVal: 1100,
                columns: [
                    {
                        title: this.$t('标识'),
                        key: 'policyName',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => h('span', { attrs: { title: this.$t(params.row.policyName) } }, this.$t(params.row.policyName))
                    },
                    {
                        title: this.$t('资源类型'),
                        key: 'resTypeName',
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        render: (h, params) => h('span', { attrs: { title: this.$t(params.row.resTypeName) } }, this.$t(params.row.resTypeName))
                    },
                    {
                        title: this.$t('分类'),
                        key: 'policyType',
                        sortable: true,
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        render: (h, params) => {
                            return h('span', { attrs: { title: this.$t(this.policyTypeName[params.row.policyType]) } }, this.$t(this.policyTypeName[params.row.policyType]))
                        }
                    },
                    {
                        title: this.$t('显示名称'),
                        key: 'displayName',
                        sortable: true,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => h('span', { attrs: { title: this.$t(params.row.displayName) } }, this.$t(params.row.displayName))
                    },
                    {
                        title: this.$t('描述'),
                        key: 'description',
                        sortable: true,
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 180,
                        render: (h, params) => h('span', { attrs: { title: this.$t(params.row.description) } }, this.$t(params.row.description))
                    },
                    {
                        title: this.$t('操作'),
                        fixed: 'right',
                        resizable: false,
                        width: 230,
                        render: (h, params) => {
                            return h('div', {
                                class: 'tbl-btn-div'
                            }, [
                                h('a', { class: { 'disabled-per': !this.hasPermission('CH0503') }, on: { click: () => this.hasPermission('CH0503') && this.associatedUserClick(params.row) } }, this.$t('关联用户/组')),
                                h('a', { class: { 'disabled-per': !this.hasPermission('CH0507') || params.row.policyType === 'system' }, on: { click: () => this.hasPermission('CH0507') && params.row.policyType !== 'system' && this.authorizeClick(params.row) } }, this.$t('授权')),
                                h('a', {
                                    class: { 'disabled-per': params.row.isShowHpcResource === false || !this.hasPermission('CH0506') },
                                    attrs: {
                                        title: this.$t('关联资源仅支持高性能计算HPC服务')
                                    },
                                    on: { click: () => params.row.isShowHpcResource !== false && this.hasPermission('CH0506') && this.associatedresourceClick(params.row) }
                                }, this.$t('关联资源')),
                                h('a', { class: { 'disabled-per': !this.hasPermission('CH0504') || params.row.policyType === 'system' }, on: { click: () => this.hasPermission('CH0504') && params.row.policyType !== 'system' && this.editClick(params.row) } }, this.$t('编辑')),
                                h('a', { class: { 'disabled-per': !this.hasPermission('CH0505') || params.row.policyType === 'system' }, on: { click: () => this.hasPermission('CH0505') && params.row.policyType !== 'system' && this.deleteClick(params.row.policySid) } }, this.$t('删除'))
                            ])
                        }
                    }
                ]
            },
            loading: false
        }
    },
    created () {
        this.getType()
    },
    methods: {
        getType () {
            // 资源类型
            this.axios.get(this.urlFormat(API.GET_CODE_DATA + '/ACCESS_RESOURCE_TYPE?statusAll=false', true)).then(res => {
                res.forEach(item => {
                    item.value = item.codeValue
                    item.name = this.$t(item.codeDisplay)
                })
                this.tableAttr.searchColumns[1].searchData = res
            })
        },
        refresh () {
            this.$refs.rcTable.refreshTable()
        },
        // 创建
        createClick () {
            this.$refs.createstrategy.openModal()
        },
        // 关联用户
        associatedUserClick (data) {
            this.$refs.associatedusers.openModal(data)
        },
        // 关联资源
        associatedresourceClick (data) {
            this.$refs.associatedresource.open(data)
        },
        // 调整权限
        authorizeClick (data) {
            this.$refs.authorize.openModal(data)
        },
        // 编辑
        editClick (data) {
            this.$refs.createstrategy.openModal(data)
        },
        // 删除
        deleteClick (id) {
            this.$Modal.confirm({
                title: this.$t('删除'),
                content: this.$t('你确定要删除该条权限配置吗?'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.ACCESS_POLICES_ID, false, [id])).then(res => {
                        this.refresh()
                    })
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background-color: white;
}
</style>
